import React, { ReactNode } from 'react'
import { Button, Tooltip } from 'antd'
import styles from './index.module.less'
import { ReactComponent as Edit } from '@/assets/icons/edit.svg'
import { ReactComponent as Delete } from '@/assets/icons/delete.svg'
import { ReactComponent as Cancel } from '@/assets/icons/cancel.svg'
import { ReactComponent as Pass } from '@/assets/icons/pass.svg'
import { ReactComponent as Move } from '@/assets/icons/move.svg'
import { ReactComponent as View } from '@/assets/icons/view.svg'
import i18n from '@/locales'

interface IProps {
  title?: string
  icon?: ReactNode
  [key: string]: any
}

const IconButton = ({ title, icon, ...rest }: IProps) => {
  const { style } = rest
  if (style && style?.display === 'none') return null
  return (
    <Tooltip title={title} placement="bottom">
      <div className={styles.iconBtn}>
        <Button type="link" {...rest}>
          {icon}
        </Button>
      </div>
    </Tooltip>
  )
}

export default IconButton

export const EditIcon = ({ ...rest }) => {
  return <IconButton icon={<Edit />} title={i18n.t('ikg.edit')} {...rest} />
}

export const DeleteIcon = ({ ...rest }) => {
  return <IconButton icon={<Delete />} title={i18n.t('ikg.delete')} {...rest} />
}

export const CancelIcon = ({ ...rest }) => {
  return <IconButton icon={<Cancel />} title={i18n.t('ikg.cancel')} {...rest} />
}

export const PassIcon = ({ ...rest }) => {
  return <IconButton icon={<Pass />} title={i18n.t('ikg.pass')} {...rest} />
}

export const MoveIcon = ({ ...rest }) => {
  return <IconButton icon={<Move />} title={i18n.t('ikg.move')} {...rest} />
}

export const ViewIcon = ({ ...rest }) => {
  // TODO: 文本需要补充到翻译文件中
  return <IconButton icon={<View />} title={i18n.t('ikg.move')} {...rest} />
}
